module.exports = __webpack_public_path__ + "img/icon-zoom-minus.a12ec4ea.svg";